var chunkToChildrenMap = {
	"9332": [
		5795,
		879,
		7947,
		7164,
		8229,
		8814,
		7697,
		2282,
		7771,
		5067
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));